import { BirdviewHomeContactType } from '../../DashboardBirdview.constants'

import BuildingIcon from '../../../../icons/building.svg'
import EmailIcon from '../../../../icons/email.svg'
import MapPinIcon from '../../../../icons/map-pin.svg'
import PhoneIcon from '../../../../icons/phone.svg'

export const BirdviewHomeRowKey = {
  Address: 'address',
  Email: 'email',
  EmergencyPhone: 'emergency_phone',
  Phone: 'phone',
  PropertyManagement: 'property_management',
}

export const BIRDVIEW_HOME_ROW = {
  [BirdviewHomeRowKey.Address]: {
    Icon: MapPinIcon,
    labelKey: 'DashboardBirdview.HomeAddressLabelKey',
  },
  [BirdviewHomeRowKey.Email]: {
    Icon: EmailIcon,
    labelKey: 'DashboardBirdview.HomeEmailLabelKey',
    type: BirdviewHomeContactType.Email,
  },
  [BirdviewHomeRowKey.EmergencyPhone]: {
    Icon: PhoneIcon,
    labelKey: 'DashboardBirdview.HomeEmergencyPhoneLabelKey',
    type: BirdviewHomeContactType.Phone,
  },
  [BirdviewHomeRowKey.Phone]: {
    Icon: PhoneIcon,
    labelKey: 'DashboardBirdview.HomePhoneLabelKey',
    type: BirdviewHomeContactType.Phone,
  },
  [BirdviewHomeRowKey.PropertyManagement]: {
    Icon: BuildingIcon,
    labelKey: 'DashboardBirdview.HomePropertyManagementLabelKey',
  },
}
